import axios from "axios";
import { useEffect, useContext } from "react";
import UserContext from "./Contexts/UserContext";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthService } from "./Services";
import { toast } from "react-toastify";
import { getDefaultUser } from "wup-module1-base";
import { AppHelpers } from "./Helpers/App/AppHelpers";

function AxiosInstance() {
  const location = useLocation();
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  let refreshTokenPromise;

  // funkcja sprawdzająca czy ścieżka jest ścieżką publiczną
  const isCurrentPathPublic = () => {
    const currentPath = window.location.pathname;
    return (
      currentPath.includes("/login") ||
      currentPath.includes("/forgotPassword") ||
      currentPath.includes("/resetPassword") ||
      currentPath.includes("/set-password")
    );
  };

  // funkcja sprawdzająca czy request zawiera "login"
  const isLoginMethod = (request) => {
    const url = request?.url || "";
    return url.includes("login");
  };

  // obsługa sukcesu
  const shouldMuteErrorLog = (url = "", status) => {
    const rules = [
      { match: "/documents/client-contract/", statuses: [404, 500] },
      { match: "/questionnaire/is-active/", statuses: [404] },
      { match: "/questionnaire/check-courses", statuses: [422, 500] },
    ];
    return rules.some(
      (r) => url.includes(r.match) && r.statuses.includes(status)
    );
  };

  // sukces
  const responseSuccess = (response) => {
    const origiRequest = response?.request?.responseURL;
    if (origiRequest?.includes("/login")) {
      refreshTokenPromise = null;
    }

    if (!response?.request?.responseURL?.includes("questionnaire/set/answer")) {
      const currentDate = new Date();
      currentDate.setMinutes(currentDate.getMinutes() + 25);
      const futureDate = currentDate.toLocaleString();
      sessionStorage.setItem("sessionDate", JSON.stringify(futureDate));
    }

    return response;
  };

  // obsługa błędów
  const responseError = async (error) => {
    const originalRequest = error?.config || {};
    const status = error?.response?.status;
    const url = originalRequest?.url || "";

    if (originalRequest?.url === "/api/token/refresh" && !isCurrentPathPublic()) {
      setUser(getDefaultUser());
      navigate("/login");
      return;
    }

    if (!shouldMuteErrorLog(url, status)) {
      console.error(error);
    }

    if (!isLoginMethod(originalRequest) && status === 401 && !originalRequest._retry) {
      if (location.pathname.includes("exclusive-offer")) {
        sessionStorage.setItem("lastExclusiveOfferPath", location.pathname);
      }
      if (location.pathname.includes("ContractForm")) {
        sessionStorage.setItem("lastExclusiveOfferPath", location.pathname);
      }
      if (location.pathname.includes("ContractFormv2")) {
        sessionStorage.setItem("lastExclusiveOfferPath", location.pathname);
      }

      originalRequest._retry = true;
      if (!refreshTokenPromise) {
        refreshTokenPromise = AuthService.refreshToken()
          .then((refreshResponse) => {
            refreshTokenPromise = null;
            return refreshResponse;
          })
          .catch(() => {
            if (!isCurrentPathPublic()) {
              navigate("/login");
            }
          });
      }
      return refreshTokenPromise?.then((response) => {
        if (response?.status === 200) {
          // setUser(response.data);
          return axios(originalRequest);
        }
      });
    }
    if (status === 403 && !isLoginMethod(originalRequest)) {
      const message = error?.response?.data?.message ?? "Brak uprawnień";
      toast.error(message, { toastId: "forbidden-toast" });
      navigate("/");
    }
    return Promise.reject(error);
  };

  // hook zapamietujacy ostatnią ścieżkę
  useEffect(() => {
    if (location.pathname.includes("exclusive-offer")) {
      sessionStorage.setItem("lastExclusiveOfferPath", location.pathname);
    }
  }, [location]);

  // rejestracja interceptorów
  useEffect(() => {
    const reqInterceptor = axios.interceptors.request.use(
      (config) => {
        if (config?.url && !config.url.startsWith("/api/")) {
          const prefix = `/api/${AppHelpers.uuidv4()}`;
          config.url = `${prefix}${config.url}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const resInterceptor = axios.interceptors.response.use(responseSuccess, responseError);

    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(resInterceptor);
    };
  }, []);

  return null;
}

export default AxiosInstance;
